import 'vite/modulepreload-polyfill';
import React from 'react';
import ReactDOM from 'react-dom/client';
import ReviewWidget from '@/components/ReviewWidget.jsx';

function readAllowCommentEdit(el) {
  const v = el.getAttribute('data-allow-comment-edit');
  return v === 'true' || v === '1';
}

/** `data-avatars`: JSON array of image URLs, e.g. `["https://...","https://..."]` (HTML-escape quotes in Liquid). */
function readAvatarsFromData(el) {
  const raw = el.getAttribute('data-avatars');
  if (raw == null || !String(raw).trim()) return undefined;

  return String(raw).split(',');
}

function readAllowOnlyOneComment(el) {
  const raw = el.getAttribute('data-allow-only-one-comment');
  if (raw === 'true') return true;
  return false;
}

const rootElement = document.getElementById('wooltari-review-widget');
if (rootElement) {
  const campaignName = rootElement.getAttribute('data-campaign-name');
  const customerId = rootElement.getAttribute('data-customer-id');
  const email = rootElement.getAttribute('data-customer-email');
  const articleId = rootElement.getAttribute('data-article-id');
  const articleHandle = rootElement.getAttribute('data-article-handle');

  // const articleId = "test"
  // const articleHandle = "test"

  const articleUrl = rootElement.getAttribute('data-article-url');
  const shopHandle = rootElement.getAttribute('data-shop-handle');
  const locale = rootElement.getAttribute('data-locale');
  const themeColor = rootElement.getAttribute('data-theme-color');
  const btnTxtColor = rootElement.getAttribute('data-btn-txt-color');
  // newest || popular
  const defaultSort = rootElement.getAttribute('data-default-sort');
  const pageSize = rootElement.getAttribute('data-page-size');
  const eventEndsAt = rootElement.getAttribute('data-event-ends-at');
  const selectAvatar = rootElement.getAttribute('data-select-avatar');
  const allowOnlyOneComment = readAllowOnlyOneComment(rootElement);
  const avatarsAttr = readAvatarsFromData(rootElement);
  const allowCommentEdit = readAllowCommentEdit(rootElement);

  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <ReviewWidget
        campaignName={campaignName}
        customerId={customerId}
        email={email}
        articleId={articleId}
        articleHandle={articleHandle}
        articleUrl={articleUrl}
        shopHandle={shopHandle}
        locale={locale}
        allowCommentEdit={allowCommentEdit}
        themeColor={themeColor}
        btnTxtColor={btnTxtColor}
        avatars={avatarsAttr}
        allowOnlyOneComment={allowOnlyOneComment}
        defaultSort={defaultSort}
        pageSize={Number(pageSize ?? 5)}
        eventEndsAt={eventEndsAt}
        selectAvatar={selectAvatar}
      />
    </React.StrictMode>,
  );
}